export default __webpack_public_path__ + "static/media/football.03ebaed9.webp";